import { z } from 'zod'
import { CASHOUT_FIELD_KEYS } from './constants'
import { cashoutFieldSchemas } from './field-schemas'

/**
 * Schema Zod solo con los campos solicitados según respuesta del servidor.
 */
export const buildCashoutSchema = (pendingFields, ctx = {}) => {
  const shape = {}
  for (const key of pendingFields) {
    const def = cashoutFieldSchemas[key]
    if (def == null) continue
    shape[key] = typeof def === 'function' ? def(ctx) : def
  }
  return z.object(shape)
}

/**
 * Schema con todos los campos de cashout (compatibilidad con el formulario actual).
 */
export const buildSchema = ({ maxAmount, last4, filedsRequired = CASHOUT_FIELD_KEYS } = {}) =>
  buildCashoutSchema(filedsRequired, { maxAmount, last4 })
